<template>
    <div class="cl-stem" @mouseenter="hovered = true" @mouseleave="hovered = false" :style="{filter: isPlaying ? 'brightness(170%)' : 'brightness(100%)'}">
        <div class="cl-stem-text" @click="onClickStem(stem.downloadUrl)">
            <div v-if="!hovered && !isPlaying" class="cl-stem-index">{{ index }}</div>
            <img v-if="hovered || isPlaying"  class="cl-stem-icon" src="../assets/image/path-down.png" alt="play">
            <div class="cl-stem-title">{{ this.stem.name }}</div>
        </div>
        <div @click.prevent="onClickDownload">
            <img src="../assets/image/download-large-grey.png" alt="download" class="cl-download-stem"/>
        </div>
    </div>
</template>
<script>
    import downloadUrl from "../util";
    export default {
      name: 'LoopStem',
      props: {
        index: {
          type: Number
        },
        stem: {
          type: Object,
          required: true
        },
        onPressStem: {
          type: Function
        },
        isPlaying: {
          type: Boolean
        }
      },
      data() {
        return {
          hovered: false,
        }
      },
      methods: {
        onClickStem(stemUrl) {
          this.onPressStem(stemUrl);
        },
        onClickDownload() {
          downloadUrl(this.stem.downloadUrl);
        }
      },
    }
</script>
<style lang="scss">
    .cl-stem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 480px;
        height: 80px;
        padding: 0 25px;
        background-color: #3d3d3d;
        border-radius: 6px;
        margin: 15px 0;
        cursor: pointer;

        &:hover {
            filter: brightness(140%);
        }
    }

    .cl-stem-text {
      display: flex;
      align-items: center;
      width: 70%;
    }

    .cl-stem-index {
        margin-right: 25px;
    }

    .cl-stem-icon {
        margin-right: 14px;
        width: 20px;
        height: 23px;
    }

    .cl-download-stem {
        width: 25px;
        height: 25px;
        cursor: pointer;

        &:hover {
            filter: brightness(110%);
        }
    }

    .cl-stem-title {
        width: 300px;
    }

    @media (min-width: 768px) and (max-width: 835px) {
        .cl-stem {
            width: 320px;
            height: 70px;
        }
    }

    @media (max-width: 600px) {
        .cl-stem {
            width: 100%;
            height: 55px;
        }

        .cl-download-stem {
            width: 21px;
            height: 21px;
        }

        .cl-stem-title {
            width: 200px;
        }
    }
</style>